import React, { useState } from "react";
import "./GetInTouchForms.css";
import { submitFormPayload } from "../utils/formSubmission";

const FEEDBACK_TYPES = ["Complaint", "Suggestion"];
const FEEDBACK_CATEGORIES = [
  "Buying Policy",
  "Making Claims",
  "Human Relations",
  "others",
];

function GetInTouchForms() {
  const [submitState, setSubmitState] = useState({
    loading: false,
    message: "",
  });













  
  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitState({ loading: true, message: "Submitting..." });

    const form = event.currentTarget;
    const formData = new FormData(form);

    const payload = {
      FB_TYPE: formData.get("fbType"),
      FB_CATEGORY: formData.get("fbCategory"),
      FB_CUST_NAME: formData.get("fullName"),
      FB_CUST_EMAIL: formData.get("email"),
      FB_CUS_PHONE: formData.get("phone"),
      FB_CUS_MESSAGE: formData.get("message"),
      FB_STATE: "Pending",
      Status: 1,
    };

    try {
      const result = await submitFormPayload("/api/feedback/", payload);

      if (result.skipped) {
        setSubmitState({ loading: false, message: "Submitted successfully." });
        form.reset();
        return;
      }

      setSubmitState({ loading: false, message: "Submitted successfully." });
      form.reset();
    } catch (error) {
      setSubmitState({
        loading: false,
        message: "Unable to submit right now. Please try again.",
      });
    }
  };

  return (
    <div className="GetInTouchForms">
      <div>
        <h1>GET IN TOUCH</h1>
        <form onSubmit={handleSubmit}>
          <div className="GetInTouchForms_InputBox_Query_all">
            <div className="GetInTouchForms_InputBox_Query">
              <input type="text" name="fullName" placeholder="Enter your name" required />
            </div>
            <div className="GetInTouchForms_InputBox_Query">
              <input type="email" name="email" placeholder="Your Email" required />
            </div>
            <div className="GetInTouchForms_InputBox_Query">
              <input
                type="tel"
                name="phone"
                placeholder="Enter your phone number"
                required
              />
            </div>
            <div className="GetInTouchForms_InputBox_Query">
              <select name="fbType" defaultValue="" required>
                <option value="" disabled>
                  Select feedback type
                </option>
                {FEEDBACK_TYPES.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
            <div className="GetInTouchForms_InputBox_Query">
              <select name="fbCategory" defaultValue="" required>
                <option value="" disabled>
                  Select category
                </option>
                {FEEDBACK_CATEGORIES.map((category) => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="GetInTouchForms_InputBox">
            <textarea name="message" type="textarea" placeholder="Remarks" required />
          </div>
          <div className="GetInTouchFomrs_Agree">
            <input type="checkbox" name="consent" required />
            <p>I agree that my submitted data is being collected and stored.</p>
          </div>
          <div className="button">
            <input type="submit" value={submitState.loading ? "SUBMITTING..." : "SUBMIT"} disabled={submitState.loading} />
          </div>
          {submitState.message && <p className="GetInTouchForms_Message">{submitState.message}</p>}
        </form>
      </div>
    </div>
  );
}

export default GetInTouchForms;
